import { useNavigate } from "react-router-dom";
import { PageHeader } from "../components/Primitives";
import { ChevronRight, Facebook, MonitorPlay, Music2 } from "lucide-react";

const cards = [
    {
        key: "meta",
        title: "Meta Ads",
        subtitle: "Facebook + Instagram. Breakdowns: placement, age, gender, region, creative.",
        path: "/detailed-reports/meta",
        icon: Facebook,
        color: "#1877F2",
        available: true,
    },
    {
        key: "dv360",
        title: "Display & Video 360",
        subtitle: "Programmatic display, video, CTV. Breakdowns: exchange, line item, creative, geo, device.",
        path: "/detailed-reports/dv360",
        icon: MonitorPlay,
        color: "#34A853",
        available: true,
    },
    {
        key: "tiktok",
        title: "TikTok Ads",
        subtitle: "TikTok Marketing API. Breakdowns: ad group, country, gender, age.",
        path: "/detailed-reports/tiktok",
        icon: Music2,
        color: "#FE2C55",
        available: true,
    },
];

export default function DetailedReports() {
    const navigate = useNavigate();
    return (
        <div data-testid="detailed-reports-platform-page">
            <PageHeader
                eyebrow="Reporting"
                title="Detailed reports"
                subtitle="Run breakdown-rich reports per platform."
            />

            <div className="grid md:grid-cols-2 gap-4">
                {cards.map((c) => {
                    const Icon = c.icon;
                    return (
                        <button
                            key={c.key}
                            disabled={!c.available}
                            onClick={() => c.available && navigate(c.path)}
                            className="text-left bg-white border border-zinc-200 hover:border-zinc-300 transition-colors p-6 rounded disabled:opacity-50 disabled:cursor-not-allowed group"
                            data-testid={`detailed-platform-${c.key}`}
                        >
                            <div className="flex items-start justify-between">
                                <div
                                    className="h-12 w-12 rounded flex items-center justify-center"
                                    style={{ background: `${c.color}15`, color: c.color }}
                                >
                                    <Icon className="h-6 w-6" strokeWidth={2} />
                                </div>
                                <ChevronRight className="h-5 w-5 text-zinc-400 group-hover:translate-x-0.5 transition-transform" />
                            </div>
                            <h3 className="font-display text-xl mt-4 text-zinc-900">{c.title}</h3>
                            <p className="text-sm text-zinc-500 mt-1 leading-relaxed">{c.subtitle}</p>
                            {!c.available && (
                                <span className="inline-block mt-3 px-2 py-0.5 rounded text-[10px] uppercase tracking-wider bg-zinc-200 text-zinc-700">Coming soon</span>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
